import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RosterIndex from '.'
import { getDropDownWatcher } from '../../../../redux/actionCreators/admin/employeeManagement'
import { getRosterWatcher } from '../../../../redux/actionCreators/admin/rosterManagement'
import RosterManagement from './rosterManagement'

export default function Roster() {

    const dispatch = useDispatch();
    const { RosterReducers: { rosterList } } = useSelector((state) => state)

    useEffect(() => {
        let data = { "ACTION": "SELECT" }
        dispatch(getRosterWatcher(data))
        dispatch(getDropDownWatcher())

    }, [dispatch])

    const roster = rosterList.length === 0 ? <RosterIndex /> : <RosterManagement />

    return (
        <>
            {roster}
        </>
    )
}
